/*
 * Read an item and try to convert it to json
 */
function read(key) {
    const stored = sessionStorage.getItem(key);
    if (!stored) {
        return null;
    }
    try {
        return JSON.parse(stored);
    }
    catch (exception) {
        return stored;
    }
}
/*
 * Write an item and if it is not a string, convert it
 */
function write(key, value) {
    sessionStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
}
/*
 * Remove an item based on its key
 */
function removeKey(key) {
    sessionStorage.removeItem(key);
}

export { read, removeKey, write };
//# sourceMappingURL=session.esm.js.map
